import L from 'leaflet'
import Control from './control'
import Vue from 'vue'
import SelectedMarkersMenu from '../../components/map/selectedMarkersMenu.vue'

export default Control.extend({
  id: 'selected-merkers',
  _initMarker: null,
  options: {
    position: 'topleft'
  },
  onAdd: function () {
    this._container = L.DomUtil.create('div')
    const div = L.DomUtil.create('div')
    this._container.appendChild(div)

    L.DomEvent.disableClickPropagation(this._container)
    L.DomEvent.disableScrollPropagation(this._container)

    const MenuClass = Vue.extend(SelectedMarkersMenu)

    this._menu = new MenuClass({
      propsData: {
        map: this._map,
        markers: this._markers,
        setInitMarker: this.setInitMarker.bind(this),
        closeControl: this._closeControl.bind(this)
      }
    })

    this._menu.$vuetify = this.options.vue.$vuetify
    this._menu.$mount(div)

    return this._container
  },
  isMarkerSelected (marker) {
    if (this._menu) {
      return marker === this.getSelectedMarker()
    }
    return false
  },
  updateMarkersList (markers) {
    this._markers = markers

    if (this._menu) {
      this._menu.updateMarkers(markers)
    }
  },
  getSelectedMarker () {
    if (this._menu) {
      return this._menu.getSelectedMarker()
    }
    return null
  },
  getSelectedIndex () {
    if (this._menu) {
      return this._menu.selectedMarkerIndex
    }
    return null
  },
  setSelectedIndex (index) {
    if (this._menu) {
      this._menu.setSelectedMarkerIndex(index)
    }
  },
  setInitMarker (marker) {
    this._initMarker = marker
  },
  getInitMarker () {
    return this._initMarker
  },
  _closeControl () {
    this._map.removeControl(this)
  },
  onRemove: function () {
    this._map.eachLayer(layer => {
      if (layer instanceof L.Marker) {
        layer.setInteractive(true)
        layer.setOpacity(1)
        layer.getElement().style.setProperty('--pseudo-backgroundcolor', layer.options.defaultColor)
      }
    })

    this._menu.$destroy()
  }
})